import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IWithStockObject } from '../../models/IWithStockObject';

@Component({
  selector: 'bufferstock-list',
  templateUrl: './bufferstock-list.component.html',
})
export class BufferstockListComponent {
  /** Array of Object with stocks */
  @Input() objectsWithStock!: IWithStockObject[];

  @Input()
  public set objectWithStock(v: IWithStockObject) {
    this.objectsWithStock = [v];
  }

  /** url of page this component is in */
  @Input() url: any;
  /** title of component */
  @Input() title!: string;

  constructor(
    public readonly router: Router,
    public readonly route: ActivatedRoute
  ) {}

  /**
   * navigates to Detail-Page of selected bufferstock
   * @param id id of selected bufferstock
   */
  openBufferstock(bufferstockId: number, locationId: number) {
    this.router.navigate(['/warehouse/bufferstocks/', bufferstockId], {
      queryParams: { location_id: locationId },
    });
  }
}
